/* eslint-disable no-dupe-keys */
const apiEndpoints = {
  prod: {
    // SPEC_MCP:API_CONFIG
    baseUrl: 'https://api.ace.online/',
    sitemapBaseUrl: 'https://ace.online/',
    cloudFrontUrl: 'https://duucnkfm18wax.cloudfront.net',
    studentResourceCloudfrontUrl: 'https://media-sr.ace.online',
    generateOTP: '/auth/internal/send/otp',
    loginURL: '/auth/login',

    // Offline Class Room endpoints
    getAllOfflineClassRooms: '/batch/api/v1/offlineclassroom/all',
    createOfflineClassRoom: '/batch/api/v1/offlineclassroom',

    //Live Updates Start
    getAllLiveClassData: '/batch/live-schedule/all',
    getAllLiveBatches: '/batch/getBatchByStatus/ACTIVE',
    getBatchInfoByStatus: '/batch/getBatchInfoByStatus/ACTIVE',
    getBatchInfoByStatusPagination: '/batch/getBatchInfoByStatus/ACTIVE/pagination',
    createLiveClass: '/batch/live-schedule/create',
    getAllBatchSubjects: '/batch/subject/all',
    getAllBatchTeachers: '/batch/teachers/all',
    getAllBatchChapters: '/batch/chapter/all',
    createBatchSubject: '/batch/subject/create',
    createBatchChapter: '/batch/chapter/create',
    deleteBatchSubject: '/batch/subject/delete/{subjectId}',
    deleteBatchChapter: '/batch/chapter/delete/{chapterId}',
    showToStudents: '/batch/live-schedule/{liveClassId}/{enabled}',
    updateLiveClass: '/batch/live-schedule/update',
    deleteLiveClass: '/batch/live-schedule/delete/{liveClassId}',
    attachLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    deleteLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    sendClassNotification: '/batch/live-schedule/{liveClassId}/send-notification',
    getAllZoomAccounts: '/batch/live-class/zoom-accounts',
    getOccupiedZoomAccounts: '/batch/live-class/zoom-accounts/occupied', //[POST]
    getBatchClassroomCenterCode: '/batch/api/v1/classroom-centre-codes/all',
    getClassRoomDetailsOfBatch: '/batch/liveclass/batchprogress/{batchId}',
    getClassRoomAttendanceDetails: '/batch/{classType}/attendance/{liveClassId}',
    getStudentsAttendanceDetails: '/batch/{classType}/attendance/students/{liveClassId}',

    //Live Updates End
    seoPages: '/publisher/api/v1/seo-pages',
    getAllUsers: '/users/user/internal/all?page=0&size=2000',
    getAllCourses: '/publisher/storemanager/course/all',
    getAllRoles: '/users/role/all',
    getAllSubjectsAdmin: '/subjects/subject/all', // [GET]

    getSubjectsByStatus: '/subjects/api/v2/subjects/status/{status}', // [GET]
    getUnitsBySubjectId: '/subjects/api/v2/subjects/info/{subjectid}', // [GET]
    getAssigneeBySubjectId: '/subjects/api/v2/assignee/{subjectid}', // [GET]
    getSubjectsByUserId: '/subjects/subjects/{userid}', // [GET]
    getUsersByRole: '/users/user/role/{role}', // [GET]
    sendForReview: '/subjects/api/v2/subjects/review/{userId}', // [POST]
    getSubjectVideos: '/file-explorer-service/api/v2/subjects/{subjectid}', // [GET]
    getSubjectAssignee: '/subjects/api/v2/assignee/{subjectId}', // [GET]

    getAllCoupons: '/publisher/coupon',
    getAllCouponsForUser: '/publisher/coupon/user',
    getMobileValidation: '/users/user/validate/{mobileNumber}',

    getAllCatalogues: '/publisher/storemanager/coupon/all',
    getAllRoles: '/users/role/all',

    attachVideoToSubTopic: '/subjects/api/v2/subjects/video', // [PUT]
    updateSubjectInfoAssignee: '/subjects/api/v2/subjects/info', // [PUT]
    updateSubjectInfo: '/subjects/api/v2/subjects', // [PUT]
    updateCoupon: '/publisher/coupon',
    declineSubject: '/subjects/api/v2/subjects/revert/{subjectId}', // no payload                      // [PUT]
    approveSubject: '/subjects/api/v2/subjects/approve', // [POST]
    deleteASubject: '/subjects/api/v2/subjects/{subjectid}', // no payload    [DELETE]

    updateSubjectInfoAssignee: '/subjects/api/v2/subjects/info', // [PUT]
    updateUser: '/users/user',

    createUser: '/users/user',
    deleteUser: '/users/user/userid/{userId}',
    createSubject: '/subjects/api/v2/subjects/info', // [POST]
    createCoupon: '/publisher/coupon',
    getVideoUrl: '/cms/pagecontent/videourl', // [POST]

    // Student Updates Start
    getAllStudentUpdates: '/notifications/notifications/getupdates',
    getStudentUpdateByUpdateType: '/notifications/notifications/getupdates/{updateType}',
    createStudentUpdate: '/notifications/notifications/createupdate',
    updateStudentUpdate: '/notifications/notifications/changeupdate',
    deleteStudentUpdate: '/notifications/notifications/deleteupdate?updateId={id}',
    // Student Updates Finish

    /* ************************************ [PUBLISHER] ************************************* */
    getNavigationMenu: '/publisher/navigation/tree',
    updateNavigationMenu: '/publisher/navigation/tree',
    createCategory: '/publisher/navigation/category/tree',
    updateCategory: '/publisher/navigation/category/tree',
    deleteNavigationCategory: '/publisher/navigation/category/{categoryId}',
    deleteLabel: '/publisher/navigation/label/{labelId}',
    deleteSubCategory: '/publisher/navigation/subcategory/{subCategoryId}',
    updateCategoryPriority: '/publisher/navigation/category/priority',

    // [CATALOGUEMANAGER] :

    // [GET]
    getCatalogueList: '/publisher/cataloguemanager/all',
    getIndividualCatalogue: '/publisher/cataloguemanager/catalogue/{catalogueid}',
    getCatalogueSubjectList: '/publisher/publisher/subject/all',

    // [POST]
    createCatalogue: '/publisher/cataloguemanager/create',

    // [PUT]
    updateCatalogue: '/publisher/cataloguemanager/update',
    updateCatalogueStatus: '/publisher/cataloguemanager/catalogue/{catalogueId}',

    // [STOREMANAGER] :
    getAllRecommendedCourses: '/publisher/storemanager/recommendation/storelisting/{id}',
    // [GET]

    getStoreList: '/publisher/storemanager/all',
    getStoreById: '/publisher/storemanager/store/{storeId}',

    // [POST]

    createStore: '/publisher/storemanager/create',

    // [PUT]

    updateStore: '/publisher/storemanager/update',
    updateCategoryOrder: '/publisher/category/order/update',
    archiveStoreListing: '/publisher/storemanager/store/archive/{storeId}',

    // [DELETE]

    deleteAStoreListing: '/publisher/storemanager/store/{storeId}',

    // [OTSMANAGER] :

    // [GET]

    getOtsCatalogueList: '/publisher/otsmanager/catalogue/all',
    getOtsSubscriptionsByID: '/publisher/otsmanager/subscription/catalogueid/{catalogueId}',

    // [POST]

    // [PUT]

    // [DELETE]

    //

    // [GET]

    getCurrentCatalogueSubjectList: '/publisher/catalogue/catalogueid/{catalogueid}/subjects',

    getCategoryList: '/publisher/category/all',

    // [POST]
    addCategory: '/publisher/category',

    // [DELETE]
    deleteCatalogue: '/publisher/catalogue/catalogueid/{catalogueId}',
    deleteCategory: '/publisher/category/{categoryId}',

    // [PUT]
    addOrUpdateCategory: '/publisher/category',
    updateSubscriptionOts: '/publisher/otsmanager/update',

    /* *************************************** [TRANSCODING MANAGER] ************************************ */

    // [GET]
    getTobeTranscodedJobs: '/file-explorer-service/api/v2/videos/to-be-trans-coded/{videoType}',

    // [POST]
    getMediaConvertJobsByStatus:
      'https://hea3usdkkc.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding',
    cancelJobs:
      'https://hea3usdkkc.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding',
    getTranscodingTemplate:
      'https://rdne34atwf.execute-api.ap-south-1.amazonaws.com/production/list-media-convert-template',
    queueArn: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Default', // Check
    queueArnReserved: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Reserved',
    createMediaConvertJob:
      'https://hea3usdkkc.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding',

    /* *************************************** [LEGAL PAGE] ************************************  */
    allTnc: '/users/tnc/all',
    updateTnc: '/users/tnc/latest',

    /* *************************************** [File Explorer] ************************************  */
    getAllSubjects: '/file-explorer-service/api/v2/subjects',
    getSubjectById: '/file-explorer-service/api/v2/subjects/{id}',
    getVideosFromTopics: '/file-explorer-service/api/v2/videos',
    getPreviewVideosCatalogue: '/file-explorer-service/api/v2/preview-videos',
    getPreviewVideosList: '/file-explorer-service/api/v2/preview-videos/{id}',

    /* [COUPONS] */
    getSingleCouponDetails: '/publisher/coupon/couponid/{id}',
    expireCoupon: '/publisher/coupon/expire/{id}',

    /* [LIVE CLASS RECORDINGS] */
    getAllLiveClassRecordings: '/file-explorer-service/api/v2/preview-videos?type=LTR',

    /* [DELIVERY MANAGEMENT] */

    // [GET]
    getDeliveriesByStatus: '/delivery/api/v2/delivery/status',
    getDeliveryPackageById: '/delivery/api/v2/delivery/{packageId}',
    getBarcodeEnvelopes: '/delivery/api/v2/delivery/envelopes',
    // [PUT]
    updateDeliveryAddress: '/delivery/api/v2/delivery/address',
    processDeliveryPackage: '/delivery/api/v2/delivery/process',
    moveDeliveryToBeDispatched: '/delivery/api/v2/delivery/bulk/to-be-dispatched',
    updateDeliveryPackage: '/delivery/api/v2/delivery',
    // [POST]
    sendHandDeliveryOtp: '/delivery/api/v2/delivery/in-hand/otp/send/{deliveryPackageId}',
    resendHandDeliveryOtp: '/delivery/api/v2/delivery/in-hand/otp/resend/{deliveryPackageId}',
    verifyHandDeliveryOtp: '/delivery/api/v2/delivery/in-hand/otp/verify',
    downloadTrackingTemplate: '/delivery/api/v2/template',
    uploadTrackingIds: '/delivery/api/v2/tracking-pool/upload',
    bulkAssignTrackingIds: '/delivery/api/v2/delivery/bulk-assign-tracking',
    bulkClearTrackingIds: '/delivery/api/v2/delivery/bulk-clear-tracking',
    // [GET]
    getStudentInfo: '/students/student/info',
    getStudentsList: '/students/api/v2/students/info',
    getSubscriptionsList: '/students/subscription/studentid',
    getSubscribedAddonsList: '/students/student/subscribed-addons',
    getInvoicesList: '/payments/student/subscription/studentid',
    verifyStudentEmail: '/users/user/autoverify/email_otp',
    getInvoice: '/payments/invoice/orderid/{orderId}',
    // [Batch management]
    getBatchList: '/batch/getAllBatch/pagination?page=0&size=10000',
    getBatchListPagination: '/batch/getAllBatch/pagination',
    createBatch: '/batch/createBatch',
    updateBatch: '/batch/updateBatch',
    closeBatch: '/batch/closeBatch/{batchId}',
    reactivateBatch: '/batch/api/v1/batches/{batchId}/reactivate',
    getBranchList: '/batch/getAllBranch',
    createBranch: '/batch/createBranch',
    getProgramList: '/batch/getAllProgram',
    createProgram: '/batch/createProgram',
    getScheduler: '/users/user/role/{roleName}',
    getBatchDetails: '/batch/getBatchById/{batchId}',
    uploadStudents: '/batch/bulkUpload',
    updateBatchOfStudents: '/batch/updateStudentsBatch',
    getStudentsListByBatch: '/batch/batch/{batchId}/allStudentIds',
    getStudentsListByStudentIds: '/students/student/byStudentIds',
    // [Group management]
    getGroupList: '/batch/groups',
    createGroup: '/batch/group',
    deleteGroup: '/batch/groups/{groupId}',
    updateGroup: '/batch/group',
    // [Feature Management]
    getFeatureList: '/publisher/storemanager/programs/features',
    updateFeature: '/publisher/storemanager/programs/features',
    createFeature: '/publisher/storemanager/programs/features',

    // [Scholarships]
    scholarship: '/publisher/api/v1/scholarship',
    scholarshipTypes: '/publisher/api/v1/scholarship/types',
    checkoutScholarship: '/publisher/api/v1/scholarship/checkout',
    studentsScholarship: '/students/api/v1/student/scholarship',
    studentScholarshipPaymentInfo: '/payments/payment/scholarship',
    studentNonScholarshipPaymentInfo: '/payments/payment/details/{studentId}',
    nonScholarshipStudents: '/students/api/v1/students/profile-verification-status',
    nonScholarshipDocuments: '/students/api/v1/documents/verification-status',
    updateDocumentsOfNonScholarshipStudents: '/students/api/v1/documents/update',

    //[Hall Tickets]
    hallTickets: '/students/api/v1/student/hall-ticket',

    //[Scholarship Types]
    scholarshipTypeList: '/publisher/api/v1/scholarship-types/all',
    scholarshipTypeById: '/publisher/api/v1/scholarship-types/{id}',
    createScholarshipType: '/publisher/api/v1/scholarship-types/create',
    updateScholarshipType: '/publisher/api/v1/scholarship-types/update/{id}',
    toggleScholarshipTypeActive: '/publisher/api/v1/scholarship-types/delete/{id}',

    //[Document Types]
    documentTypeList: '/publisher/api/v1/document-types/all',
    documentTypeById: '/publisher/api/v1/document-types/{id}',
    createDocumentType: '/publisher/api/v1/document-types/create',
    updateDocumentType: '/publisher/api/v1/document-types/update/{id}',
    toggleDocumentTypeActive: '/publisher/api/v1/document-types/delete/{id}',

    //Finance Dashboard
    payments: '/payments/orders/invoices',

    // User Device
    resetDevice: '/users/v1/devices/primary/reset',
    requestPrimaryDeviceModification: '/users/v1/devices/primary/request', // POST
    fetchPrimaryDevices: '/users/v1/devices/primary/support', // GET
    retriveLastAccessedDevicesInfo: '/users/v1/devices/access/history', // POST

    //[Marketing Campaigns]
    campaigns: '/publisher/api/v1/campaigns',
    campaign: '/publisher/api/v1/campaigns/{campaignId}',
    createCampaign: '/publisher/api/v1/campaigns',
    updateCampaign: '/publisher/api/v1/campaigns',
    activateCampaign: '/publisher/api/v1/campaigns/{campaignId}/{active}',
    subcategoryStoreListings: '/publisher/subcategories/storelistings',
  },
  preProd: {
    // SPEC_MCP:API_CONFIG
    baseUrl: 'https://pre-prod-api.ace.online',
    sitemapBaseUrl: 'https://ace.online/',
    cloudFrontUrl: 'https://duucnkfm18wax.cloudfront.net',
    studentResourceCloudfrontUrl: 'https://media-sr.ace.online',
    generateOTP: '/auth/internal/send/otp',
    loginURL: '/auth/login',

    // Offline Class Room endpoints
    getAllOfflineClassRooms: '/batch/api/v1/offlineclassroom/all',
    createOfflineClassRoom: '/batch/api/v1/offlineclassroom',

    //Live Updates Start
    getAllLiveClassData: '/batch/live-schedule/all',
    getAllLiveBatches: '/batch/getBatchByStatus/ACTIVE',
    getBatchInfoByStatus: '/batch/getBatchInfoByStatus/ACTIVE',
    getBatchInfoByStatusPagination: '/batch/getBatchInfoByStatus/ACTIVE/pagination',
    createLiveClass: '/batch/live-schedule/create',
    getAllBatchSubjects: '/batch/subject/all',
    getAllBatchTeachers: '/batch/teachers/all',
    getAllBatchChapters: '/batch/chapter/all',
    createBatchSubject: '/batch/subject/create',
    createBatchChapter: '/batch/chapter/create',
    deleteBatchSubject: '/batch/subject/delete/{subjectId}',
    deleteBatchChapter: '/batch/chapter/delete/{chapterId}',
    showToStudents: '/batch/live-schedule/{liveClassId}/{enabled}',
    updateLiveClass: '/batch/live-schedule/update',
    deleteLiveClass: '/batch/live-schedule/delete/{liveClassId}',
    attachLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    deleteLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    sendClassNotification: '/batch/live-schedule/{liveClassId}/send-notification',
    getAllZoomAccounts: '/batch/live-class/zoom-accounts',
    getOccupiedZoomAccounts: '/batch/live-class/zoom-accounts/occupied', //[POST]
    getBatchClassroomCenterCode: '/batch/api/v1/classroom-centre-codes/all',
    getClassRoomDetailsOfBatch: '/batch/liveclass/batchprogress/{batchId}',
    getClassRoomAttendanceDetails: '/batch/{classType}/attendance/{liveClassId}',
    getStudentsAttendanceDetails: '/batch/{classType}/attendance/students/{liveClassId}',
    //Live Updates End

    seoPages: '/publisher/api/v1/seo-pages',
    getAllUsers: '/users/user/internal/all?page=0&size=2000',
    getAllCourses: '/publisher/storemanager/course/all',
    getAllRoles: '/users/role/all',
    getAllSubjectsAdmin: '/subjects/subject/all', // [GET]
    getSubjectsByStatus: '/subjects/api/v2/subjects/status/{status}', // [GET]
    getUnitsBySubjectId: '/subjects/api/v2/subjects/info/{subjectid}', // [GET]
    getAssigneeBySubjectId: '/subjects/api/v2/assignee/{subjectid}', // [GET]
    getSubjectsByUserId: '/subjects/subjects/{userid}', // [GET]
    getUsersByRole: '/users/user/role/{role}', // [GET]
    sendForReview: '/subjects/api/v2/subjects/review/{userId}', // [POST]
    getSubjectVideos: '/file-explorer-service/api/v2/subjects/{subjectid}', // [GET]
    getSubjectAssignee: '/subjects/api/v2/assignee/{subjectId}', // [GET]

    getAllCoupons: '/publisher/coupon',
    getAllCouponsForUser: '/publisher/coupon/user',
    getMobileValidation: '/users/user/validate/{mobileNumber}',

    getAllCatalogues: '/publisher/storemanager/coupon/all',
    getAllRoles: '/users/role/all',

    attachVideoToSubTopic: '/subjects/api/v2/subjects/video', // [PUT]
    updateSubjectInfoAssignee: '/subjects/api/v2/subjects/info', // [PUT]
    updateSubjectInfo: '/subjects/api/v2/subjects', // [PUT]
    updateCoupon: '/publisher/coupon',
    declineSubject: '/subjects/api/v2/subjects/revert/{subjectId}', // no payload                      // [PUT]
    approveSubject: '/subjects/api/v2/subjects/approve', // [POST]
    deleteASubject: '/subjects/api/v2/subjects/{subjectid}', // no payload    [DELETE]

    updateSubjectInfoAssignee: '/subjects/api/v2/subjects/info', // [PUT]
    updateUser: '/users/user',

    createUser: '/users/user',
    deleteUser: '/users/user/userid/{userId}',
    createSubject: '/subjects/api/v2/subjects/info', // [POST]
    createCoupon: '/publisher/coupon',
    getVideoUrl: '/cms/pagecontent/videourl', // [POST]

    // Student Updates Start
    getAllStudentUpdates: '/notifications/notifications/getupdates',
    getStudentUpdateByUpdateType: '/notifications/notifications/getupdates/{updateType}',
    createStudentUpdate: '/notifications/notifications/createupdate',
    updateStudentUpdate: '/notifications/notifications/changeupdate',
    deleteStudentUpdate: '/notifications/notifications/deleteupdate?updateId={id}',
    // Student Updates Finish

    /* ************************************ [PUBLISHER] ************************************* */
    getNavigationMenu: '/publisher/navigation/tree',
    updateNavigationMenu: '/publisher/navigation/tree',
    createCategory: '/publisher/navigation/category/tree',
    updateCategory: '/publisher/navigation/category/tree',
    deleteNavigationCategory: '/publisher/navigation/category/{categoryId}',
    deleteLabel: '/publisher/navigation/label/{labelId}',
    deleteSubCategory: '/publisher/navigation/subcategory/{subCategoryId}',
    updateCategoryPriority: '/publisher/navigation/category/priority',

    // [CATALOGUEMANAGER] :

    // [GET]
    getCatalogueList: '/publisher/cataloguemanager/all',
    getIndividualCatalogue: '/publisher/cataloguemanager/catalogue/{catalogueid}',
    getCatalogueSubjectList: '/publisher/publisher/subject/all',

    // [POST]
    createCatalogue: '/publisher/cataloguemanager/create',

    // [PUT]
    updateCatalogue: '/publisher/cataloguemanager/update',
    updateCatalogueStatus: '/publisher/cataloguemanager/catalogue/{catalogueId}',

    // [STOREMANAGER] :
    getAllRecommendedCourses: '/publisher/storemanager/recommendation/storelisting/{id}',
    // [GET]

    getStoreList: '/publisher/storemanager/all',
    getStoreById: '/publisher/storemanager/store/{storeId}',

    // [POST]

    createStore: '/publisher/storemanager/create',

    // [PUT]

    updateStore: '/publisher/storemanager/update',
    updateCategoryOrder: '/publisher/category/order/update',
    archiveStoreListing: '/publisher/storemanager/store/archive/{storeId}',

    // [DELETE]

    deleteAStoreListing: '/publisher/storemanager/store/{storeId}',

    // [OTSMANAGER] :

    // [GET]

    getOtsCatalogueList: '/publisher/otsmanager/catalogue/all',
    getOtsSubscriptionsByID: '/publisher/otsmanager/subscription/catalogueid/{catalogueId}',

    // [POST]

    // [PUT]

    // [DELETE]

    //

    // [GET]

    getCurrentCatalogueSubjectList: '/publisher/catalogue/catalogueid/{catalogueid}/subjects',

    getCategoryList: '/publisher/category/all',

    // [POST]
    addCategory: '/publisher/category',

    // [DELETE]
    deleteCatalogue: '/publisher/catalogue/catalogueid/{catalogueId}',
    deleteCategory: '/publisher/category/{categoryId}',

    // [PUT]
    addOrUpdateCategory: '/publisher/category',
    updateSubscriptionOts: '/publisher/otsmanager/update',

    /* *************************************** [TRANSCODING MANAGER] ************************************ */

    // [GET]
    getTobeTranscodedJobs: '/file-explorer-service/api/v2/videos/to-be-trans-coded/{videoType}',

    // [POST]
    getMediaConvertJobsByStatus:
      'https://hea3usdkkc.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding',
    cancelJobs:
      'https://hea3usdkkc.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding',
    getTranscodingTemplate:
      'https://rdne34atwf.execute-api.ap-south-1.amazonaws.com/production/list-media-convert-template',
    queueArn: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Default', // Check
    queueArnReserved: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Reserved',
    createMediaConvertJob:
      'https://hea3usdkkc.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding',

    /* *************************************** [LEGAL PAGE] ************************************  */
    allTnc: '/users/tnc/all',
    updateTnc: '/users/tnc/latest',

    /* *************************************** [File Explorer] ************************************  */
    getAllSubjects: '/file-explorer-service/api/v2/subjects',
    getSubjectById: '/file-explorer-service/api/v2/subjects/{id}',
    getVideosFromTopics: '/file-explorer-service/api/v2/videos',
    getPreviewVideosCatalogue: '/file-explorer-service/api/v2/preview-videos',
    getPreviewVideosList: '/file-explorer-service/api/v2/preview-videos/{id}',

    /* [COUPONS] */
    getSingleCouponDetails: '/publisher/coupon/couponid/{id}',
    expireCoupon: '/publisher/coupon/expire/{id}',

    /* [LIVE CLASS RECORDINGS] */
    getAllLiveClassRecordings: '/file-explorer-service/api/v2/preview-videos?type=LTR',

    /* [DELIVERY MANAGEMENT] */

    // [GET]
    getDeliveriesByStatus: '/delivery/api/v2/delivery/status',
    getDeliveryPackageById: '/delivery/api/v2/delivery/{packageId}',
    getBarcodeEnvelopes: '/delivery/api/v2/delivery/envelopes',
    // [PUT]
    updateDeliveryAddress: '/delivery/api/v2/delivery/address',
    processDeliveryPackage: '/delivery/api/v2/delivery/process',
    moveDeliveryToBeDispatched: '/delivery/api/v2/delivery/bulk/to-be-dispatched',
    updateDeliveryPackage: '/delivery/api/v2/delivery',
    // [POST]
    sendHandDeliveryOtp: '/delivery/api/v2/delivery/in-hand/otp/send/{deliveryPackageId}',
    resendHandDeliveryOtp: '/delivery/api/v2/delivery/in-hand/otp/resend/{deliveryPackageId}',
    verifyHandDeliveryOtp: '/delivery/api/v2/delivery/in-hand/otp/verify',
    downloadTrackingTemplate: '/delivery/api/v2/template',
    uploadTrackingIds: '/delivery/api/v2/tracking-pool/upload',
    bulkAssignTrackingIds: '/delivery/api/v2/delivery/bulk-assign-tracking',
    bulkClearTrackingIds: '/delivery/api/v2/delivery/bulk-clear-tracking',
    // [GET]
    getStudentInfo: '/students/student/info',
    getStudentsList: '/students/api/v2/students/info',
    getSubscriptionsList: '/students/subscription/studentid',
    getSubscribedAddonsList: '/students/student/subscribed-addons',
    getInvoicesList: '/payments/student/subscription/studentid',
    verifyStudentEmail: '/users/user/autoverify/email_otp',
    getInvoice: '/payments/invoice/orderid/{orderId}',
    // [Batch management]
    getBatchList: '/batch/getAllBatch/pagination?page=0&size=10000',
    getBatchListPagination: '/batch/getAllBatch/pagination',
    createBatch: '/batch/createBatch',
    updateBatch: '/batch/updateBatch',
    closeBatch: '/batch/closeBatch/{batchId}',
    reactivateBatch: '/batch/api/v1/batches/{batchId}/reactivate',
    getBranchList: '/batch/getAllBranch',
    createBranch: '/batch/createBranch',
    getProgramList: '/batch/getAllProgram',
    createProgram: '/batch/createProgram',
    getScheduler: '/users/user/role/{roleName}',
    getBatchDetails: '/batch/getBatchById/{batchId}',
    uploadStudents: '/batch/bulkUpload',
    updateBatchOfStudents: '/batch/updateStudentsBatch',
    getStudentsListByBatch: '/batch/batch/{batchId}/allStudentIds',
    getStudentsListByStudentIds: '/students/student/byStudentIds',
    // [Group management]
    getGroupList: '/batch/groups',
    createGroup: '/batch/group',
    deleteGroup: '/batch/groups/{groupId}',
    updateGroup: '/batch/group',
    // [Feature Management]
    getFeatureList: '/publisher/storemanager/programs/features',
    updateFeature: '/publisher/storemanager/programs/features',
    createFeature: '/publisher/storemanager/programs/features',

    // [Scholarships]
    scholarship: '/publisher/api/v1/scholarship',
    scholarshipTypes: '/publisher/api/v1/scholarship/types',
    checkoutScholarship: '/publisher/api/v1/scholarship/checkout',
    studentsScholarship: '/students/api/v1/student/scholarship',
    studentScholarshipPaymentInfo: '/payments/payment/scholarship',
    studentNonScholarshipPaymentInfo: '/payments/payment/details/{studentId}',
    nonScholarshipStudents: '/students/api/v1/students/profile-verification-status',
    nonScholarshipDocuments: '/students/api/v1/documents/verification-status',
    updateDocumentsOfNonScholarshipStudents: '/students/api/v1/documents/update',

    //[Hall Tickets]
    hallTickets: '/students/api/v1/student/hall-ticket',

    //[Scholarship Types]
    scholarshipTypeList: '/publisher/api/v1/scholarship-types/all',
    scholarshipTypeById: '/publisher/api/v1/scholarship-types/{id}',
    createScholarshipType: '/publisher/api/v1/scholarship-types/create',
    updateScholarshipType: '/publisher/api/v1/scholarship-types/update/{id}',
    toggleScholarshipTypeActive: '/publisher/api/v1/scholarship-types/delete/{id}',

    //[Document Types]
    documentTypeList: '/publisher/api/v1/document-types/all',
    documentTypeById: '/publisher/api/v1/document-types/{id}',
    createDocumentType: '/publisher/api/v1/document-types/create',
    updateDocumentType: '/publisher/api/v1/document-types/update/{id}',
    toggleDocumentTypeActive: '/publisher/api/v1/document-types/delete/{id}',

    //Finance Dashboard
    payments: '/payments/orders/invoices',
    // User Device
    resetDevice: '/users/v1/devices/primary/reset',
    requestPrimaryDeviceModification: '/users/v1/devices/primary/request', // POST
    fetchPrimaryDevices: '/users/v1/devices/primary/support', // GET
    retriveLastAccessedDevicesInfo: '/users/v1/devices/access/history', // POST

    //[Marketing Campaigns]
    campaigns: '/publisher/api/v1/campaigns',
    campaign: '/publisher/api/v1/campaigns/{campaignId}',
    createCampaign: '/publisher/api/v1/campaigns',
    updateCampaign: '/publisher/api/v1/campaigns',
    activateCampaign: '/publisher/api/v1/campaigns/{campaignId}/{active}',
    subcategoryStoreListings: '/publisher/subcategories/storelistings',
  },
  staging: {
    // SPEC_MCP:API_CONFIG
    baseUrl: 'https://api-staging.ace.online',
    sitemapBaseUrl: 'https://staging.ace.online/',
    cloudFrontUrl: 'https://d2aetrhkp37yll.cloudfront.net',
    studentResourceCloudfrontUrl: 'https://media-sr-test.ace.online',
    generateOTP: '/auth/internal/send/otp',
    loginURL: '/auth/login',

    // Offline Class Room endpoints
    getAllOfflineClassRooms: '/batch/api/v1/offlineclassroom/all',
    createOfflineClassRoom: '/batch/api/v1/offlineclassroom',

    //Live Updates Start
    getAllLiveClassData: '/batch/live-schedule/all',
    getAllLiveBatches: '/batch/getBatchByStatus/ACTIVE',
    getBatchInfoByStatus: '/batch/getBatchInfoByStatus/ACTIVE',
    getBatchInfoByStatusPagination: '/batch/getBatchInfoByStatus/ACTIVE/pagination',
    createLiveClass: '/batch/live-schedule/create',
    getAllBatchSubjects: '/batch/subject/all',
    getAllBatchTeachers: '/batch/teachers/all',
    getAllBatchChapters: '/batch/chapter/all',
    createBatchSubject: '/batch/subject/create',
    createBatchChapter: '/batch/chapter/create',
    deleteBatchSubject: '/batch/subject/delete/{subjectId}',
    deleteBatchChapter: '/batch/chapter/delete/{chapterId}',
    showToStudents: '/batch/live-schedule/{liveClassId}/{enabled}',
    updateLiveClass: '/batch/live-schedule/update',
    deleteLiveClass: '/batch/live-schedule/delete/{liveClassId}',
    attachLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    deleteLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    sendClassNotification: '/batch/live-schedule/{liveClassId}/send-notification',
    getAllZoomAccounts: '/batch/live-class/zoom-accounts',
    getOccupiedZoomAccounts: '/batch/live-class/zoom-accounts/occupied', //[POST]
    getBatchClassroomCenterCode: '/batch/api/v1/classroom-centre-codes/all',
    getClassRoomDetailsOfBatch: '/batch/liveclass/batchprogress/{batchId}',
    getClassRoomAttendanceDetails: '/batch/{classType}/attendance/{liveClassId}',
    getStudentsAttendanceDetails: '/batch/{classType}/attendance/students/{liveClassId}',

    //Live Updates End

    seoPages: '/publisher/api/v1/seo-pages',
    getAllUsers: '/users/user/internal/all?page=0&size=2000',
    getAllCourses: '/publisher/storemanager/course/all',
    getAllRoles: '/users/role/all',
    getAllSubjectsAdmin: '/subjects/subject/all', // [GET]
    getSubjectsInprogress: '/subjects/subjects/inprogress', // [GET]
    getSubjectsFinished: '/subjects/subjects/finished', // [GET]
    getSubjectsByStatus: '/subjects/api/v2/subjects/status/{status}', // [GET]
    getUnitsBySubjectId: '/subjects/api/v2/subjects/info/{subjectid}', // [GET]
    getAssigneeBySubjectId: '/subjects/api/v2/assignee/{subjectid}', // [GET]
    getSubjectsByUserId: '/subjects/subjects/{userid}', // [GET]
    getUsersByRole: '/users/user/role/{role}', // [GET]
    sendForReview: '/subjects/api/v2/subjects/review/{userId}', // [POST]
    getSubjectVideos: '/file-explorer-service/api/v2/subjects/{subjectid}', // [GET]
    getAllCoupons: '/publisher/coupon',
    getAllCouponsForUser: '/publisher/coupon/user',
    getSubjectAssignee: '/subjects/api/v2/assignee/{subjectId}', // [GET]

    getMobileValidation: '/users/user/validate/{mobileNumber}',

    getAllCatalogues: '/publisher/storemanager/coupon/all',
    getAllRoles: '/users/role/all',

    attachVideoToSubTopic: '/subjects/api/v2/subjects/video', // [PUT]
    updateSubjectInfoAssignee: '/subjects/api/v2/subjects/info', // [PUT]
    updateSubjectInfo: '/subjects/api/v2/subjects', // [PUT]
    updateCoupon: '/publisher/coupon',
    declineSubject: '/subjects/api/v2/subjects/revert/{subjectId}', // no payload                      // [PUT]
    approveSubject: '/subjects/api/v2/subjects/approve', // [POST]

    deleteASubject: '/subjects/api/v2/subjects/{subjectid}', // no payload    [DELETE]

    updateSubjectInfoAssignee: '/subjects/api/v2/subjects/info', // [PUT]
    updateUser: '/users/user',

    createUser: '/users/user',
    deleteUser: '/users/user/userid/{userId}',
    createSubject: '/subjects/api/v2/subjects/info', // [POST]
    createCoupon: '/publisher/coupon',
    getVideoUrl: '/cms/pagecontent/videourl', // [POST]

    // Student Updates Start
    getAllStudentUpdates: '/notifications/notifications/getupdates',
    getStudentUpdateByUpdateType: '/notifications/notifications/getupdates/{updateType}',
    createStudentUpdate: '/notifications/notifications/createupdate',
    updateStudentUpdate: '/notifications/notifications/changeupdate',
    deleteStudentUpdate: '/notifications/notifications/deleteupdate?updateId={id}',
    // Student Updates Finish

    /* ************************************ [PUBLISHER] ************************************* */
    getNavigationMenu: '/publisher/navigation/tree',
    updateNavigationMenu: '/publisher/navigation/tree',
    createCategory: '/publisher/navigation/category/tree',
    updateCategory: '/publisher/navigation/category/tree',
    deleteNavigationCategory: '/publisher/navigation/category/{categoryId}',
    deleteLabel: '/publisher/navigation/label/{labelId}',
    deleteSubCategory: '/publisher/navigation/subcategory/{subCategoryId}',
    updateCategoryPriority: '/publisher/navigation/category/priority',

    // [CATALOGUEMANAGER] :

    // [GET]
    getCatalogueList: '/publisher/cataloguemanager/all',
    getIndividualCatalogue: '/publisher/cataloguemanager/catalogue/{catalogueid}',
    getCatalogueSubjectList: '/publisher/publisher/subject/all',

    // [POST]
    createCatalogue: '/publisher/cataloguemanager/create',

    // [PUT]
    updateCatalogue: '/publisher/cataloguemanager/update',
    updateCatalogueStatus: '/publisher/cataloguemanager/catalogue/{catalogueId}',

    // [STOREMANAGER] :
    getAllRecommendedCourses: '/publisher/storemanager/recommendation/storelisting/{id}',
    // [GET]

    getStoreList: '/publisher/storemanager/all',
    getStoreById: '/publisher/storemanager/store/{storeId}',

    // [POST]

    createStore: '/publisher/storemanager/create',

    // [PUT]

    updateStore: '/publisher/storemanager/update',
    updateCategoryOrder: '/publisher/category/order/update',
    archiveStoreListing: '/publisher/storemanager/store/archive/{storeId}',

    // [DELETE]

    deleteAStoreListing: '/publisher/storemanager/store/{storeId}',

    // [OTSMANAGER] :

    // [GET]

    getOtsCatalogueList: '/publisher/otsmanager/catalogue/all',
    getOtsSubscriptionsByID: '/publisher/otsmanager/subscription/catalogueid/{catalogueId}',

    // [POST]

    // [PUT]

    // [DELETE]

    //

    // [GET]
    getCurrentCatalogueSubjectList: '/publisher/catalogue/catalogueid/{catalogueid}/subjects',

    getCategoryList: '/publisher/category/all',

    // [POST]
    addCategory: '/publisher/category',

    // [DELETE]
    deleteCatalogue: '/publisher/catalogue/catalogueid/{catalogueId}',
    deleteCategory: '/publisher/category/{categoryId}',

    // [PUT]
    addOrUpdateCategory: '/publisher/category',
    updateSubscriptionOts: '/publisher/otsmanager/update',

    /* *************************************** [TRANSCODING MANAGER] ************************************ */

    // [GET]
    getTobeTranscodedJobs: '/file-explorer-service/api/v2/videos/to-be-trans-coded/{videoType}',

    // [POST]
    getMediaConvertJobsByStatus:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',
    cancelJobs:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',
    getTranscodingTemplate:
      'https://w1dxgfnb25.execute-api.ap-south-1.amazonaws.com/development/list-media-convert-template',
    queueArn: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Default', // Check
    queueArnReserved: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Reserved',
    createMediaConvertJob:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',

    /* *************************************** [LEGAL PAGE] ************************************  */
    allTnc: '/users/tnc/all',
    updateTnc: '/users/tnc/latest',

    /* *************************************** [File Explorer] ************************************  */
    getAllSubjects: '/file-explorer-service/api/v2/subjects',
    getSubjectById: '/file-explorer-service/api/v2/subjects/{id}',
    getVideosFromTopics: '/file-explorer-service/api/v2/videos',
    getPreviewVideosCatalogue: '/file-explorer-service/api/v2/preview-videos',
    getPreviewVideosList: '/file-explorer-service/api/v2/preview-videos/{id}',
    /* [COUPONS] */
    getSingleCouponDetails: '/publisher/coupon/couponid/{id}',
    expireCoupon: '/publisher/coupon/expire/{id}',

    /* [LIVE CLASS RECORDINGS] */
    getAllLiveClassRecordings: '/file-explorer-service/api/v2/preview-videos?type=LTR',

    /* [DELIVERY MANAGEMENT] */

    // [GET]
    getDeliveriesByStatus: '/delivery/api/v2/delivery/status',
    getDeliveryPackageById: '/delivery/api/v2/delivery/{packageId}',
    getBarcodeEnvelopes: '/delivery/api/v2/delivery/envelopes',
    // [PUT]
    updateDeliveryAddress: '/delivery/api/v2/delivery/address',
    processDeliveryPackage: '/delivery/api/v2/delivery/process',
    moveDeliveryToBeDispatched: '/delivery/api/v2/delivery/bulk/to-be-dispatched',
    updateDeliveryPackage: '/delivery/api/v2/delivery',
    // [POST]
    sendHandDeliveryOtp: '/delivery/api/v2/delivery/in-hand/otp/send/{deliveryPackageId}',
    resendHandDeliveryOtp: '/delivery/api/v2/delivery/in-hand/otp/resend/{deliveryPackageId}',
    verifyHandDeliveryOtp: '/delivery/api/v2/delivery/in-hand/otp/verify',
    downloadTrackingTemplate: '/delivery/api/v2/template',
    uploadTrackingIds: '/delivery/api/v2/tracking-pool/upload',
    bulkAssignTrackingIds: '/delivery/api/v2/delivery/bulk-assign-tracking',
    bulkClearTrackingIds: '/delivery/api/v2/delivery/bulk-clear-tracking',
    // [GET]
    getStudentInfo: '/students/student/info',
    getStudentsList: '/students/api/v2/students/info',
    getSubscriptionsList: '/students/subscription/studentid',
    getSubscribedAddonsList: '/students/student/subscribed-addons',
    getInvoicesList: '/payments/student/subscription/studentid',
    verifyStudentEmail: '/users/user/autoverify/email_otp',
    getInvoice: '/payments/invoice/orderid/{orderId}',
    // [Batch management]
    getBatchList: '/batch/getAllBatch/pagination?page=0&size=10000',
    getBatchListPagination: '/batch/getAllBatch/pagination',
    createBatch: '/batch/createBatch',
    updateBatch: '/batch/updateBatch',
    closeBatch: '/batch/closeBatch/{batchId}',
    reactivateBatch: '/batch/api/v1/batches/{batchId}/reactivate',
    getBranchList: '/batch/getAllBranch',
    createBranch: '/batch/createBranch',
    getProgramList: '/batch/getAllProgram',
    createProgram: '/batch/createProgram',
    getScheduler: '/users/user/role/{roleName}',
    getBatchDetails: '/batch/getBatchById/{batchId}',
    uploadStudents: '/batch/bulkUpload',
    updateBatchOfStudents: '/batch/updateStudentsBatch',
    getStudentsListByBatch: '/batch/batch/{batchId}/allStudentIds',
    getStudentsListByStudentIds: '/students/student/byStudentIds',
    // [Group management]
    getGroupList: '/batch/groups',
    createGroup: '/batch/group',
    deleteGroup: '/batch/groups/{groupId}',
    updateGroup: '/batch/group',
    // [Feature Management]
    getFeatureList: '/publisher/storemanager/programs/features',
    updateFeature: '/publisher/storemanager/programs/features',
    createFeature: '/publisher/storemanager/programs/features',

    // [Scholarships]
    scholarship: '/publisher/api/v1/scholarship',
    scholarshipTypes: '/publisher/api/v1/scholarship/types',
    checkoutScholarship: '/publisher/api/v1/scholarship/checkout',
    studentsScholarship: '/students/api/v1/student/scholarship',
    studentScholarshipPaymentInfo: '/payments/payment/scholarship',
    studentNonScholarshipPaymentInfo: '/payments/payment/details/{studentId}',
    nonScholarshipStudents: '/students/api/v1/students/profile-verification-status',
    nonScholarshipDocuments: '/students/api/v1/documents/verification-status',
    updateDocumentsOfNonScholarshipStudents: '/students/api/v1/documents/update',

    //[Hall Tickets]
    hallTickets: '/students/api/v1/student/hall-ticket',

    //[Scholarship Types]
    scholarshipTypeList: '/publisher/api/v1/scholarship-types/all',
    scholarshipTypeById: '/publisher/api/v1/scholarship-types/{id}',
    createScholarshipType: '/publisher/api/v1/scholarship-types/create',
    updateScholarshipType: '/publisher/api/v1/scholarship-types/update/{id}',
    toggleScholarshipTypeActive: '/publisher/api/v1/scholarship-types/delete/{id}',

    //[Document Types]
    documentTypeList: '/publisher/api/v1/document-types/all',
    documentTypeById: '/publisher/api/v1/document-types/{id}',
    createDocumentType: '/publisher/api/v1/document-types/create',
    updateDocumentType: '/publisher/api/v1/document-types/update/{id}',
    toggleDocumentTypeActive: '/publisher/api/v1/document-types/delete/{id}',

    //Finance Dashboard
    payments: '/payments/orders/invoices',
    // User Device
    resetDevice: '/users/v1/devices/primary/reset',
    requestPrimaryDeviceModification: '/users/v1/devices/primary/request', // POST
    fetchPrimaryDevices: '/users/v1/devices/primary/support', // GET
    retriveLastAccessedDevicesInfo: '/users/v1/devices/access/history', // POST

    //[Marketing Campaigns]
    campaigns: '/publisher/api/v1/campaigns',
    campaign: '/publisher/api/v1/campaigns/{campaignId}',
    createCampaign: '/publisher/api/v1/campaigns',
    updateCampaign: '/publisher/api/v1/campaigns',
    activateCampaign: '/publisher/api/v1/campaigns/{campaignId}/{active}',
    subcategoryStoreListings: '/publisher/subcategories/storelistings',
  },

  test: {
    // SPEC_MCP:API_CONFIG
    baseUrl: 'https://api-test.ace.online',
    sitemapBaseUrl: 'https://test.ace.online/',
    cloudFrontUrl: 'https://d2aetrhkp37yll.cloudfront.net',
    studentResourceCloudfrontUrl: 'https://media-sr-test.ace.online',
    generateOTP: '/auth/internal/send/otp',
    loginURL: '/auth/login',

    // Offline Class Room endpoints
    getAllOfflineClassRooms: '/batch/api/v1/offlineclassroom/all',
    createOfflineClassRoom: '/batch/api/v1/offlineclassroom',

    //Live Updates Start
    getAllLiveClassData: '/batch/live-schedule/all',
    getAllLiveBatches: '/batch/getBatchByStatus/ACTIVE',
    getBatchInfoByStatus: '/batch/getBatchInfoByStatus/ACTIVE',
    getBatchInfoByStatusPagination: '/batch/getBatchInfoByStatus/ACTIVE/pagination',
    createLiveClass: '/batch/live-schedule/create',
    getAllBatchSubjects: '/batch/subject/all',
    getAllBatchTeachers: '/batch/teachers/all',
    getAllBatchChapters: '/batch/chapter/all',
    createBatchSubject: '/batch/subject/create',
    createBatchChapter: '/batch/chapter/create',
    deleteBatchSubject: '/batch/subject/delete/{subjectId}',
    deleteBatchChapter: '/batch/chapter/delete/{chapterId}',
    showToStudents: '/batch/live-schedule/{liveClassId}/{enabled}',
    updateLiveClass: '/batch/live-schedule/update',
    deleteLiveClass: '/batch/live-schedule/delete/{liveClassId}',
    attachLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    deleteLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    sendClassNotification: '/batch/live-schedule/{liveClassId}/send-notification',
    getAllZoomAccounts: '/batch/live-class/zoom-accounts',
    getOccupiedZoomAccounts: '/batch/live-class/zoom-accounts/occupied', //[POST]
    getBatchClassroomCenterCode: '/batch/api/v1/classroom-centre-codes/all',
    getClassRoomDetailsOfBatch: '/batch/liveclass/batchprogress/{batchId}',
    getClassRoomAttendanceDetails: '/batch/{classType}/attendance/{liveClassId}',
    getStudentsAttendanceDetails: '/batch/{classType}/attendance/students/{liveClassId}',

    //Live Updates End

    seoPages: '/publisher/api/v1/seo-pages',
    getAllUsers: '/users/user/internal/all?page=0&size=2000',
    getAllCourses: '/publisher/storemanager/course/all',
    getAllRoles: '/users/role/all',
    getAllSubjectsAdmin: '/subjects/subject/all', // [GET]
    getSubjectsByStatus: '/subjects/api/v2/subjects/status/{status}', // [GET]
    getUnitsBySubjectId: '/subjects/api/v2/subjects/info/{subjectid}', // [GET]
    getAssigneeBySubjectId: '/subjects/api/v2/assignee/{subjectid}', // [GET]
    getSubjectsByUserId: '/subjects/subjects/{userid}', // [GET]
    getUsersByRole: '/users/user/role/{role}', // [GET]
    sendForReview: '/subjects/api/v2/subjects/review/{userId}', // [POST]
    getSubjectVideos: '/file-explorer-service/api/v2/subjects/{subjectid}', // [GET]
    getSubjectAssignee: '/subjects/api/v2/assignee/{subjectId}', // [GET]

    getAllCoupons: '/publisher/coupon',
    getAllCouponsForUser: '/publisher/coupon/user',
    getMobileValidation: '/users/user/validate/{mobileNumber}',

    getAllCatalogues: '/publisher/storemanager/coupon/all',
    getAllRoles: '/users/role/all',

    attachVideoToSubTopic: '/subjects/api/v2/subjects/video', // [PUT]
    updateSubjectInfoAssignee: '/subjects/api/v2/subjects/info', // [PUT]
    updateSubjectInfo: '/subjects/api/v2/subjects', // [PUT]
    updateCoupon: '/publisher/coupon',
    declineSubject: '/subjects/api/v2/subjects/revert/{subjectId}', // no payload                      // [PUT]
    approveSubject: '/subjects/api/v2/subjects/approve', // [POST]

    deleteASubject: '/subjects/api/v2/subjects/{subjectid}', // no payload    [DELETE]

    updateSubjectInfoAssignee: '/subjects/api/v2/subjects/info', // [PUT]
    updateUser: '/users/user',

    createUser: '/users/user',
    deleteUser: '/users/user/userid/{userId}',
    createSubject: '/subjects/api/v2/subjects/info', // [POST]
    createCoupon: '/publisher/coupon',
    getVideoUrl: '/cms/pagecontent/videourl', // [POST]

    // Student Updates Start
    getAllStudentUpdates: '/notifications/notifications/getupdates',
    getStudentUpdateByUpdateType: '/notifications/notifications/getupdates/{updateType}',
    createStudentUpdate: '/notifications/notifications/createupdate',
    updateStudentUpdate: '/notifications/notifications/changeupdate',
    deleteStudentUpdate: '/notifications/notifications/deleteupdate?updateId={id}',

    /* ************************************ [PUBLISHER] ************************************* */
    getNavigationMenu: '/publisher/navigation/tree',
    updateNavigationMenu: '/publisher/navigation/tree',
    createCategory: '/publisher/navigation/category/tree',
    updateCategory: '/publisher/navigation/category/tree',
    deleteNavigationCategory: '/publisher/navigation/category/{categoryId}',
    deleteLabel: '/publisher/navigation/label/{labelId}',
    deleteSubCategory: '/publisher/navigation/subcategory/{subCategoryId}',
    updateCategoryPriority: '/publisher/navigation/category/priority',

    // [CATALOGUEMANAGER] :

    // [GET]
    getCatalogueList: '/publisher/cataloguemanager/all',
    getIndividualCatalogue: '/publisher/cataloguemanager/catalogue/{catalogueid}',
    getCatalogueSubjectList: '/publisher/publisher/subject/all',

    // [POST]
    createCatalogue: '/publisher/cataloguemanager/create',

    // [PUT]
    updateCatalogue: '/publisher/cataloguemanager/update',
    updateCatalogueStatus: '/publisher/cataloguemanager/catalogue/{catalogueId}',

    // [STOREMANAGER] :
    getAllRecommendedCourses: '/publisher/storemanager/recommendation/storelisting/{id}',
    // [GET]

    getStoreList: '/publisher/storemanager/all',
    getStoreById: '/publisher/storemanager/store/{storeId}',

    // [POST]

    createStore: '/publisher/storemanager/create',

    // [PUT]

    updateStore: '/publisher/storemanager/update',
    updateCategoryOrder: '/publisher/category/order/update',
    archiveStoreListing: '/publisher/storemanager/store/archive/{storeId}',

    // [DELETE]

    deleteAStoreListing: '/publisher/storemanager/store/{storeId}',

    // [OTSMANAGER] :

    // [GET]

    getOtsCatalogueList: '/publisher/otsmanager/catalogue/all',
    getOtsSubscriptionsByID: '/publisher/otsmanager/subscription/catalogueid/{catalogueId}',

    // [POST]

    // [PUT]

    // [DELETE]

    //

    // [GET]
    getCurrentCatalogueSubjectList: '/publisher/catalogue/catalogueid/{catalogueid}/subjects',

    getCategoryList: '/publisher/category/all',

    // [POST]
    addCategory: '/publisher/category',

    // [DELETE]
    deleteCatalogue: '/publisher/catalogue/catalogueid/{catalogueId}',
    deleteCategory: '/publisher/category/{categoryId}',

    // [PUT]
    addOrUpdateCategory: '/publisher/category',
    updateSubscriptionOts: '/publisher/otsmanager/update',

    /* *************************************** [TRANSCODING MANAGER] ************************************ */

    // [GET]
    getTobeTranscodedJobs: '/file-explorer-service/api/v2/videos/to-be-trans-coded/{videoType}',

    // [POST]
    getMediaConvertJobsByStatus:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',
    cancelJobs:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',
    getTranscodingTemplate:
      'https://w1dxgfnb25.execute-api.ap-south-1.amazonaws.com/development/list-media-convert-template',
    queueArn: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Default',
    queueArnReserved: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Reserved',
    createMediaConvertJob:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',

    /* *************************************** [LEGAL PAGE] ************************************  */
    allTnc: '/users/tnc/all',
    updateTnc: '/users/tnc/latest',

    /* *************************************** [File Explorer] ************************************  */
    getAllSubjects: '/file-explorer-service/api/v2/subjects',
    getSubjectById: '/file-explorer-service/api/v2/subjects/{id}',
    getVideosFromTopics: '/file-explorer-service/api/v2/videos',
    getPreviewVideosCatalogue: '/file-explorer-service/api/v2/preview-videos',
    getPreviewVideosList: '/file-explorer-service/api/v2/preview-videos/{id}',
    /* [COUPONS] */
    getSingleCouponDetails: '/publisher/coupon/couponid/{id}',
    expireCoupon: '/publisher/coupon/expire/{id}',

    /* [LIVE CLASS RECORDINGS] */
    getAllLiveClassRecordings: '/file-explorer-service/api/v2/preview-videos?type=LTR',

    /* [DELIVERY MANAGEMENT] */

    // [GET]
    getDeliveriesByStatus: '/delivery/api/v2/delivery/status',
    getDeliveryPackageById: '/delivery/api/v2/delivery/{packageId}',
    getBarcodeEnvelopes: '/delivery/api/v2/delivery/envelopes',
    // [PUT]
    updateDeliveryAddress: '/delivery/api/v2/delivery/address',
    processDeliveryPackage: '/delivery/api/v2/delivery/process',
    moveDeliveryToBeDispatched: '/delivery/api/v2/delivery/bulk/to-be-dispatched',
    updateDeliveryPackage: '/delivery/api/v2/delivery',
    // [POST]
    sendHandDeliveryOtp: '/delivery/api/v2/delivery/in-hand/otp/send/{deliveryPackageId}',
    resendHandDeliveryOtp: '/delivery/api/v2/delivery/in-hand/otp/resend/{deliveryPackageId}',
    verifyHandDeliveryOtp: '/delivery/api/v2/delivery/in-hand/otp/verify',
    downloadTrackingTemplate: '/delivery/api/v2/template',
    uploadTrackingIds: '/delivery/api/v2/tracking-pool/upload',
    bulkAssignTrackingIds: '/delivery/api/v2/delivery/bulk-assign-tracking',
    bulkClearTrackingIds: '/delivery/api/v2/delivery/bulk-clear-tracking',
    // [GET]
    getStudentInfo: '/students/student/info',
    getStudentsList: '/students/api/v2/students/info',
    getSubscriptionsList: '/students/subscription/studentid',
    getSubscribedAddonsList: '/students/student/subscribed-addons',
    getInvoicesList: '/payments/student/subscription/studentid',
    verifyStudentEmail: '/users/user/autoverify/email_otp',
    getInvoice: '/payments/invoice/orderid/{orderId}',
    // [Batch management]
    getBatchList: '/batch/getAllBatch/pagination?page=0&size=10000',
    getBatchListPagination: '/batch/getAllBatch/pagination',
    createBatch: '/batch/createBatch',
    updateBatch: '/batch/updateBatch',
    closeBatch: '/batch/closeBatch/{batchId}',
    reactivateBatch: '/batch/api/v1/batches/{batchId}/reactivate',
    getBranchList: '/batch/getAllBranch',
    createBranch: '/batch/createBranch',
    getProgramList: '/batch/getAllProgram',
    createProgram: '/batch/createProgram',
    getScheduler: '/users/user/role/{roleName}',
    getBatchDetails: '/batch/getBatchById/{batchId}',
    uploadStudents: '/batch/bulkUpload',
    updateBatchOfStudents: '/batch/updateStudentsBatch',
    getStudentsListByBatch: '/batch/batch/{batchId}/allStudentIds',
    getStudentsListByStudentIds: '/students/student/byStudentIds',
    // [Group management]
    getGroupList: '/batch/groups',
    createGroup: '/batch/group',
    deleteGroup: '/batch/groups/{groupId}',
    updateGroup: '/batch/group',
    // [Feature Management]
    getFeatureList: '/publisher/storemanager/programs/features',
    updateFeature: '/publisher/storemanager/programs/features',
    createFeature: '/publisher/storemanager/programs/features',

    // [Scholarships]
    scholarship: '/publisher/api/v1/scholarship',
    scholarshipTypes: '/publisher/api/v1/scholarship/types',
    checkoutScholarship: '/publisher/api/v1/scholarship/checkout',
    studentsScholarship: '/students/api/v1/student/scholarship',
    studentScholarshipPaymentInfo: '/payments/payment/scholarship',
    studentNonScholarshipPaymentInfo: '/payments/payment/details/{studentId}',
    nonScholarshipStudents: '/students/api/v1/students/profile-verification-status',
    nonScholarshipDocuments: '/students/api/v1/documents/verification-status',
    updateDocumentsOfNonScholarshipStudents: '/students/api/v1/documents/update',

    //[Hall Tickets]
    hallTickets: '/students/api/v1/student/hall-ticket',

    //[Scholarship Types]
    scholarshipTypeList: '/publisher/api/v1/scholarship-types/all',
    scholarshipTypeById: '/publisher/api/v1/scholarship-types/{id}',
    createScholarshipType: '/publisher/api/v1/scholarship-types/create',
    updateScholarshipType: '/publisher/api/v1/scholarship-types/update/{id}',
    toggleScholarshipTypeActive: '/publisher/api/v1/scholarship-types/delete/{id}',

    //[Document Types]
    documentTypeList: '/publisher/api/v1/document-types/all',
    documentTypeById: '/publisher/api/v1/document-types/{id}',
    createDocumentType: '/publisher/api/v1/document-types/create',
    updateDocumentType: '/publisher/api/v1/document-types/update/{id}',
    toggleDocumentTypeActive: '/publisher/api/v1/document-types/delete/{id}',

    //Finance Dashboard
    payments: '/payments/orders/invoices',

    // User Device
    resetDevice: '/users/v1/devices/primary/reset',
    requestPrimaryDeviceModification: '/users/v1/devices/primary/request', // POST
    fetchPrimaryDevices: '/users/v1/devices/primary/support', // GET
    retriveLastAccessedDevicesInfo: '/users/v1/devices/access/history', // POST

    //[Marketing Campaigns]
    campaigns: '/publisher/api/v1/campaigns',
    campaign: '/publisher/api/v1/campaigns/{campaignId}',
    createCampaign: '/publisher/api/v1/campaigns',
    updateCampaign: '/publisher/api/v1/campaigns',
    activateCampaign: '/publisher/api/v1/campaigns/{campaignId}/{active}',
    subcategoryStoreListings: '/publisher/subcategories/storelistings',
  },

  dev: {
    // SPEC_MCP:API_CONFIG
    baseUrl: 'https://api-dev.ace.online',
    sitemapBaseUrl: 'https://dev.ace.online/',
    cloudFrontUrl: 'https://d2aetrhkp37yll.cloudfront.net',
    studentResourceCloudfrontUrl: 'https://media-sr-test.ace.online',
    generateOTP: '/auth/internal/send/otp',
    loginURL: '/auth/login',

    // Offline Class Room endpoints
    getAllOfflineClassRooms: '/batch/api/v1/offlineclassroom/all',
    createOfflineClassRoom: '/batch/api/v1/offlineclassroom',
    //Live Updates Start
    getAllLiveClassData: '/batch/live-schedule/all',
    getAllLiveBatches: '/batch/getBatchByStatus/ACTIVE',
    getBatchInfoByStatus: '/batch/getBatchInfoByStatus/ACTIVE',
    getBatchInfoByStatusPagination: '/batch/getBatchInfoByStatus/ACTIVE/pagination',
    createLiveClass: '/batch/live-schedule/create',
    getAllBatchSubjects: '/batch/subject/all',
    getAllBatchTeachers: '/batch/teachers/all',
    getAllBatchChapters: '/batch/chapter/all',
    createBatchSubject: '/batch/subject/create',
    createBatchChapter: '/batch/chapter/create',
    deleteBatchSubject: '/batch/subject/delete/{subjectId}',
    deleteBatchChapter: '/batch/chapter/delete/{chapterId}',
    showToStudents: '/batch/live-schedule/{liveClassId}/{enabled}',
    updateLiveClass: '/batch/live-schedule/update',
    deleteLiveClass: '/batch/live-schedule/delete/{liveClassId}',
    attachLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    deleteLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    sendClassNotification: '/batch/live-schedule/{liveClassId}/send-notification',
    getAllZoomAccounts: '/batch/live-class/zoom-accounts',
    getOccupiedZoomAccounts: '/batch/live-class/zoom-accounts/occupied', //[POST]
    getBatchClassroomCenterCode: '/batch/api/v1/classroom-centre-codes/all',
    getClassRoomDetailsOfBatch: '/batch/liveclass/batchprogress/{batchId}',
    getClassRoomAttendanceDetails: '/batch/{classType}/attendance/{liveClassId}',
    getStudentsAttendanceDetails: '/batch/{classType}/attendance/students/{liveClassId}',
    //Live Updates End

    seoPages: '/publisher/api/v1/seo-pages',
    getAllUsers: '/users/user/internal/all?page=0&size=2000',
    getAllCourses: '/publisher/storemanager/course/all',
    getAllRoles: '/users/role/all',
    getAllSubjectsAdmin: '/subjects/subject/all', // [GET]
    getSubjectsByStatus: '/subjects/api/v2/subjects/status/{status}', // [GET]
    getUnitsBySubjectId: '/subjects/api/v2/subjects/info/{subjectid}', // [GET]
    getAssigneeBySubjectId: '/subjects/api/v2/assignee/{subjectid}', // [GET]
    getSubjectsByUserId: '/subjects/subjects/{userid}', // [GET]
    getUsersByRole: '/users/user/role/{role}', // [GET]
    sendForReview: '/subjects/api/v2/subjects/review/{userId}', // [POST]
    getSubjectVideos: '/file-explorer-service/api/v2/subjects/{subjectid}', // [GET]
    getSubjectAssignee: '/subjects/api/v2/assignee/{subjectId}', // [GET]

    getAllCoupons: '/publisher/coupon',
    getAllCouponsForUser: '/publisher/coupon/user',
    getMobileValidation: '/users/user/validate/{mobileNumber}',

    getAllCatalogues: '/publisher/storemanager/coupon/all',
    getAllRoles: '/users/role/all',

    attachVideoToSubTopic: '/subjects/api/v2/subjects/video', // [PUT]
    updateSubjectInfoAssignee: '/subjects/api/v2/subjects/info', // [PUT]
    updateSubjectInfo: '/subjects/api/v2/subjects', // [PUT]
    updateCoupon: '/publisher/coupon',
    declineSubject: '/subjects/api/v2/subjects/revert/{subjectId}', // no payload                      // [PUT]
    approveSubject: '/subjects/api/v2/subjects/approve', // [POST]

    deleteASubject: '/subjects/api/v2/subjects/{subjectid}', // no payload    [DELETE]

    updateSubjectInfoAssignee: '/subjects/api/v2/subjects/info', // [PUT]
    updateUser: '/users/user',

    createUser: '/users/user',
    deleteUser: '/users/user/userid/{userId}',
    createSubject: '/subjects/api/v2/subjects/info', // [POST]
    createCoupon: '/publisher/coupon',
    getVideoUrl: '/cms/pagecontent/videourl', // [POST]

    //Student updates start
    getAllStudentUpdates: '/notifications/notifications/getupdates',
    getStudentUpdateByUpdateType: '/notifications/notifications/getupdates/{updateType}',
    createStudentUpdate: '/notifications/notifications/createupdate',
    updateStudentUpdate: '/notifications/notifications/changeupdate',
    deleteStudentUpdate: '/notifications/notifications/deleteupdate?updateId={id}',
    //Student updates end

    /* ************************************ [PUBLISHER] ************************************* */
    getNavigationMenu: '/publisher/navigation/tree',
    updateNavigationMenu: '/publisher/navigation/tree',
    createCategory: '/publisher/navigation/category/tree',
    updateCategory: '/publisher/navigation/category/tree',
    deleteNavigationCategory: '/publisher/navigation/category/{categoryId}',
    deleteLabel: '/publisher/navigation/label/{labelId}',
    deleteSubCategory: '/publisher/navigation/subcategory/{subCategoryId}',
    updateCategoryPriority: '/publisher/navigation/category/priority',

    // [CATALOGUEMANAGER] :

    // [GET]
    getCatalogueList: '/publisher/cataloguemanager/all',
    getIndividualCatalogue: '/publisher/cataloguemanager/catalogue/{catalogueid}',
    getCatalogueSubjectList: '/publisher/publisher/subject/all',

    // [POST]
    createCatalogue: '/publisher/cataloguemanager/create',

    // [PUT]
    updateCatalogue: '/publisher/cataloguemanager/update',
    updateCatalogueStatus: '/publisher/cataloguemanager/catalogue/{catalogueId}',

    // [STOREMANAGER] :
    getAllRecommendedCourses: '/publisher/storemanager/recommendation/storelisting/{id}',
    // [GET]

    getStoreList: '/publisher/storemanager/all',
    getStoreById: '/publisher/storemanager/store/{storeId}',

    // [POST]

    createStore: '/publisher/storemanager/create',

    // [PUT]

    updateStore: '/publisher/storemanager/update',
    updateCategoryOrder: '/publisher/category/order/update',
    archiveStoreListing: '/publisher/storemanager/store/archive/{storeId}',

    // [DELETE]

    deleteAStoreListing: '/publisher/storemanager/store/{storeId}',

    // [OTSMANAGER] :

    // [GET]

    getOtsCatalogueList: '/publisher/otsmanager/catalogue/all',
    getOtsSubscriptionsByID: '/publisher/otsmanager/subscription/catalogueid/{catalogueId}',

    // [POST]

    // [PUT]

    // [DELETE]

    //

    // [GET]
    getCurrentCatalogueSubjectList: '/publisher/catalogue/catalogueid/{catalogueid}/subjects',

    getCategoryList: '/publisher/category/all',

    // [POST]
    addCategory: '/publisher/category',

    // [DELETE]
    deleteCatalogue: '/publisher/catalogue/catalogueid/{catalogueId}',
    deleteCategory: '/publisher/category/{categoryId}',

    // [PUT]
    addOrUpdateCategory: '/publisher/category',
    updateSubscriptionOts: '/publisher/otsmanager/update',

    /* *************************************** [TRANSCODING MANAGER] ************************************ */

    // [GET]
    getTobeTranscodedJobs: '/file-explorer-service/api/v2/videos/to-be-trans-coded/{videoType}',

    // [POST]
    getMediaConvertJobsByStatus:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',
    cancelJobs:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',
    getTranscodingTemplate:
      'https://w1dxgfnb25.execute-api.ap-south-1.amazonaws.com/development/list-media-convert-template',
    queueArn: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Default',
    queueArnReserved: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Reserved',
    createMediaConvertJob:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',

    /* *************************************** [LEGAL PAGE] ************************************  */
    allTnc: '/users/tnc/all',
    updateTnc: '/users/tnc/latest',

    /* *************************************** [File Explorer] ************************************  */
    getAllSubjects: '/file-explorer-service/api/v2/subjects',
    getSubjectById: '/file-explorer-service/api/v2/subjects/{id}',
    getVideosFromTopics: '/file-explorer-service/api/v2/videos',
    getPreviewVideosCatalogue: '/file-explorer-service/api/v2/preview-videos',
    getPreviewVideosList: '/file-explorer-service/api/v2/preview-videos/{id}',
    /* [COUPONS] */
    getSingleCouponDetails: '/publisher/coupon/couponid/{id}',
    expireCoupon: '/publisher/coupon/expire/{id}',

    /* [LIVE CLASS RECORDINGS] */
    getAllLiveClassRecordings: '/file-explorer-service/api/v2/preview-videos?type=LTR',

    /* [DELIVERY MANAGEMENT] */

    // [GET]
    getDeliveriesByStatus: '/delivery/api/v2/delivery/status',
    getDeliveryPackageById: '/delivery/api/v2/delivery/{packageId}',
    getBarcodeEnvelopes: '/delivery/api/v2/delivery/envelopes',
    // [PUT]
    updateDeliveryAddress: '/delivery/api/v2/delivery/address',
    processDeliveryPackage: '/delivery/api/v2/delivery/process',
    moveDeliveryToBeDispatched: '/delivery/api/v2/delivery/bulk/to-be-dispatched',
    updateDeliveryPackage: '/delivery/api/v2/delivery',
    // [POST]
    sendHandDeliveryOtp: '/delivery/api/v2/delivery/in-hand/otp/send/{deliveryPackageId}',
    resendHandDeliveryOtp: '/delivery/api/v2/delivery/in-hand/otp/resend/{deliveryPackageId}',
    verifyHandDeliveryOtp: '/delivery/api/v2/delivery/in-hand/otp/verify',
    downloadTrackingTemplate: '/delivery/api/v2/template',
    uploadTrackingIds: '/delivery/api/v2/tracking-pool/upload',
    bulkAssignTrackingIds: '/delivery/api/v2/delivery/bulk-assign-tracking',
    bulkClearTrackingIds: '/delivery/api/v2/delivery/bulk-clear-tracking',
    // [GET]
    getStudentInfo: '/students/student/info',
    getStudentsList: '/students/api/v2/students/info',
    getSubscriptionsList: '/students/subscription/studentid',
    getSubscribedAddonsList: '/students/student/subscribed-addons',
    getInvoicesList: '/payments/student/subscription/studentid',
    verifyStudentEmail: '/users/user/autoverify/email_otp',
    getInvoice: '/payments/invoice/orderid/{orderId}',

    // [Batch management]
    getBatchList: '/batch/getAllBatch/pagination?page=0&size=10000',
    getBatchListPagination: '/batch/getAllBatch/pagination',
    createBatch: '/batch/createBatch',
    updateBatch: '/batch/updateBatch',
    closeBatch: '/batch/closeBatch/{batchId}',
    reactivateBatch: '/batch/api/v1/batches/{batchId}/reactivate',
    getBranchList: '/batch/getAllBranch',
    createBranch: '/batch/createBranch',
    getProgramList: '/batch/getAllProgram',
    createProgram: '/batch/createProgram',
    getScheduler: '/users/user/role/{roleName}',
    getBatchDetails: '/batch/getBatchById/{batchId}',
    uploadStudents: '/batch/bulkUpload',
    updateBatchOfStudents: '/batch/updateStudentsBatch',
    getStudentsListByBatch: '/batch/batch/{batchId}/allStudentIds',
    getStudentsListByStudentIds: '/students/student/byStudentIds',
    // [Group management]
    getGroupList: '/batch/groups',
    createGroup: '/batch/group',
    deleteGroup: '/batch/groups/{groupId}',
    updateGroup: '/batch/group',
    // [Feature Management]
    getFeatureList: '/publisher/storemanager/programs/features',
    updateFeature: '/publisher/storemanager/programs/features',
    createFeature: '/publisher/storemanager/programs/features',

    // [Scholarships]
    scholarship: '/publisher/api/v1/scholarship',
    scholarshipTypes: '/publisher/api/v1/scholarship/types',
    checkoutScholarship: '/publisher/api/v1/scholarship/checkout',
    studentsScholarship: '/students/api/v1/student/scholarship',
    studentScholarshipPaymentInfo: '/payments/payment/scholarship',
    studentNonScholarshipPaymentInfo: '/payments/payment/details/{studentId}',
    nonScholarshipStudents: '/students/api/v1/students/profile-verification-status',
    nonScholarshipDocuments: '/students/api/v1/documents/verification-status',
    updateDocumentsOfNonScholarshipStudents: '/students/api/v1/documents/update',

    //[Hall Tickets]
    hallTickets: '/students/api/v1/student/hall-ticket',

    //[Scholarship Types]
    scholarshipTypeList: '/publisher/api/v1/scholarship-types/all',
    scholarshipTypeById: '/publisher/api/v1/scholarship-types/{id}',
    createScholarshipType: '/publisher/api/v1/scholarship-types/create',
    updateScholarshipType: '/publisher/api/v1/scholarship-types/update/{id}',
    toggleScholarshipTypeActive: '/publisher/api/v1/scholarship-types/delete/{id}',

    //[Document Types]
    documentTypeList: '/publisher/api/v1/document-types/all',
    documentTypeById: '/publisher/api/v1/document-types/{id}',
    createDocumentType: '/publisher/api/v1/document-types/create',
    updateDocumentType: '/publisher/api/v1/document-types/update/{id}',
    toggleDocumentTypeActive: '/publisher/api/v1/document-types/delete/{id}',

    //Finance Dashboard
    payments: '/payments/orders/invoices',

    // User Device
    resetDevice: '/users/v1/devices/primary/reset',
    requestPrimaryDeviceModification: '/users/v1/devices/primary/request', // POST
    fetchPrimaryDevices: '/users/v1/devices/primary/support', // GET
    retriveLastAccessedDevicesInfo: '/users/v1/devices/access/history', // POST

    //[Marketing Campaigns]
    campaigns: '/publisher/api/v1/campaigns',
    campaign: '/publisher/api/v1/campaigns/{campaignId}',
    createCampaign: '/publisher/api/v1/campaigns',
    updateCampaign: '/publisher/api/v1/campaigns',
    activateCampaign: '/publisher/api/v1/campaigns/{campaignId}/{active}',
    subcategoryStoreListings: '/publisher/subcategories/storelistings',
  },

  local: {
    // SPEC_MCP:API_CONFIG
    baseUrl: 'https://api-test.ace.online',
    sitemapBaseUrl: 'https://test.ace.online/',
    cloudFrontUrl: 'https://d2aetrhkp37yll.cloudfront.net',
    studentResourceCloudfrontUrl: 'https://media-sr-test.ace.online',
    generateOTP: '/auth/internal/send/otp',
    loginURL: '/auth/login',

    // Offline Class Room endpoints
    getAllOfflineClassRooms: '/batch/api/v1/offlineclassroom/all',
    createOfflineClassRoom: '/batch/api/v1/offlineclassroom',

    //Live Updates Start
    getAllLiveClassData: '/batch/live-schedule/all',
    getAllLiveBatches: '/batch/getBatchByStatus/ACTIVE',
    getBatchInfoByStatus: '/batch/getBatchInfoByStatus/ACTIVE',
    getBatchInfoByStatusPagination: '/batch/getBatchInfoByStatus/ACTIVE/pagination',
    createLiveClass: '/batch/live-schedule/create',
    getAllBatchSubjects: '/batch/subject/all',
    getAllBatchTeachers: '/batch/teachers/all',
    getAllBatchChapters: '/batch/chapter/all',
    createBatchSubject: '/batch/subject/create',
    createBatchChapter: '/batch/chapter/create',
    deleteBatchSubject: '/batch/subject/delete/{subjectId}',
    deleteBatchChapter: '/batch/chapter/delete/{chapterId}',
    showToStudents: '/batch/live-schedule/{liveClassId}/{enabled}',
    updateLiveClass: '/batch/live-schedule/update',
    deleteLiveClass: '/batch/live-schedule/delete/{liveClassId}',
    attachLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    deleteLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    sendClassNotification: '/batch/live-schedule/{liveClassId}/send-notification',
    getAllZoomAccounts: '/batch/live-class/zoom-accounts',
    getOccupiedZoomAccounts: '/batch/live-class/zoom-accounts/occupied', //[POST]
    getBatchClassroomCenterCode: '/batch/api/v1/classroom-centre-codes/all',
    getClassRoomDetailsOfBatch: '/batch/liveclass/batchprogress/{batchId}',
    getClassRoomAttendanceDetails: '/batch/{classType}/attendance/{liveClassId}',
    getStudentsAttendanceDetails: '/batch/{classType}/attendance/students/{liveClassId}',
    //Live Updates End

    // Student Updates Start
    getAllStudentUpdates: '/notifications/notifications/getupdates',
    getStudentUpdateByUpdateType: '/notifications/notifications/getupdates/{updateType}',
    createStudentUpdate: '/notifications/notifications/createupdate',
    updateStudentUpdate: '/notifications/notifications/changeupdate',
    deleteStudentUpdate: '/notifications/notifications/deleteupdate?updateId={id}',
    // Student Updates Finish

    seoPages: '/publisher/api/v1/seo-pages',
    getAllUsers: '/users/user/internal/all?page=0&size=2000',
    getAllCourses: '/publisher/storemanager/course/all',
    getAllRoles: '/users/role/all',
    getAllSubjectsAdmin: '/subjects/subject/all', // [GET]
    getSubjectsByStatus: '/subjects/api/v2/subjects/status/{status}', // [GET]
    getUnitsBySubjectId: '/subjects/api/v2/subjects/info/{subjectid}', // [GET]
    getAssigneeBySubjectId: '/subjects/api/v2/assignee/{subjectid}', // [GET]
    getSubjectsByUserId: '/subjects/subjects/{userid}', // [GET]
    getUsersByRole: '/users/user/role/{role}', // [GET]
    sendForReview: '/subjects/api/v2/subjects/review/{userId}', // [POST]
    getSubjectVideos: '/file-explorer-service/api/v2/subjects/{subjectid}', // [GET]
    getSubjectAssignee: '/subjects/api/v2/assignee/{subjectId}', // [GET]

    getAllCoupons: '/publisher/coupon',
    getAllCouponsForUser: '/publisher/coupon/user',
    getMobileValidation: '/users/user/validate/{mobileNumber}',

    getAllCatalogues: '/publisher/storemanager/coupon/all',
    getAllRoles: '/users/role/all',

    attachVideoToSubTopic: '/subjects/api/v2/subjects/video', // [PUT]
    updateSubjectInfoAssignee: '/subjects/api/v2/subjects/info', // [PUT]
    updateSubjectInfo: '/subjects/api/v2/subjects', // [PUT]
    updateCoupon: '/publisher/coupon',
    declineSubject: '/subjects/api/v2/subjects/revert/{subjectId}', // no payload                      // [PUT]
    approveSubject: '/subjects/api/v2/subjects/approve', // [POST]

    deleteASubject: '/subjects/api/v2/subjects/{subjectid}', // no payload    [DELETE]

    updateSubjectInfoAssignee: '/subjects/api/v2/subjects/info', // [PUT]
    updateUser: '/users/user',

    createUser: '/users/user',
    deleteUser: '/users/user/userid/{userId}',
    createSubject: '/subjects/api/v2/subjects/info', // [POST]
    createCoupon: '/publisher/coupon',
    getVideoUrl: '/cms/pagecontent/videourl', // [POST]

    /* ************************************ [PUBLISHER] ************************************* */
    getNavigationMenu: '/publisher/navigation/tree',
    updateNavigationMenu: '/publisher/navigation/tree',
    createCategory: '/publisher/navigation/category/tree',
    updateCategory: '/publisher/navigation/category/tree',
    deleteNavigationCategory: '/publisher/navigation/category/{categoryId}',
    deleteLabel: '/publisher/navigation/label/{labelId}',
    deleteSubCategory: '/publisher/navigation/subcategory/{subCategoryId}',
    updateCategoryPriority: '/publisher/navigation/category/priority',

    // [CATALOGUEMANAGER] :

    // [GET]
    getCatalogueList: '/publisher/cataloguemanager/all',
    getIndividualCatalogue: '/publisher/cataloguemanager/catalogue/{catalogueid}',
    getCatalogueSubjectList: '/publisher/publisher/subject/all',

    // [POST]
    createCatalogue: '/publisher/cataloguemanager/create',

    // [PUT]
    updateCatalogue: '/publisher/cataloguemanager/update',
    updateCatalogueStatus: '/publisher/cataloguemanager/catalogue/{catalogueId}',

    // [STOREMANAGER] :
    getAllRecommendedCourses: '/publisher/storemanager/recommendation/storelisting/{id}',
    // [GET]

    getStoreList: '/publisher/storemanager/all',
    getStoreById: '/publisher/storemanager/store/{storeId}',

    // [POST]

    createStore: '/publisher/storemanager/create',

    // [PUT]

    updateStore: '/publisher/storemanager/update',
    updateCategoryOrder: '/publisher/category/order/update',
    archiveStoreListing: '/publisher/storemanager/store/archive/{storeId}',

    // [DELETE]

    deleteAStoreListing: '/publisher/storemanager/store/{storeId}',

    // [OTSMANAGER] :

    // [GET]

    getOtsCatalogueList: '/publisher/otsmanager/catalogue/all',
    getOtsSubscriptionsByID: '/publisher/otsmanager/subscription/catalogueid/{catalogueId}',

    // [POST]

    // [PUT]

    // [DELETE]

    //

    // [GET]
    getCurrentCatalogueSubjectList: '/publisher/catalogue/catalogueid/{catalogueid}/subjects',

    getCategoryList: '/publisher/category/all',

    // [POST]
    addCategory: '/publisher/category',

    // [DELETE]
    deleteCatalogue: '/publisher/catalogue/catalogueid/{catalogueId}',
    deleteCategory: '/publisher/category/{categoryId}',

    // [PUT]
    addOrUpdateCategory: '/publisher/category',
    updateSubscriptionOts: '/publisher/otsmanager/update',

    /* *************************************** [TRANSCODING MANAGER] ************************************ */

    // [GET]
    getTobeTranscodedJobs: '/file-explorer-service/api/v2/videos/to-be-trans-coded/{videoType}',

    // [POST]
    getMediaConvertJobsByStatus:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',
    cancelJobs:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',
    getTranscodingTemplate:
      'https://w1dxgfnb25.execute-api.ap-south-1.amazonaws.com/development/list-media-convert-template',
    queueArn: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Default',
    queueArnReserved: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Reserved',
    createMediaConvertJob:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',

    /* *************************************** [LEGAL PAGE] ************************************  */
    allTnc: '/users/tnc/all',
    updateTnc: '/users/tnc/latest',

    /* *************************************** [File Explorer] ************************************  */
    getAllSubjects: '/file-explorer-service/api/v2/subjects',
    getSubjectById: '/file-explorer-service/api/v2/subjects/{id}',
    getVideosFromTopics: '/file-explorer-service/api/v2/videos',
    getPreviewVideosCatalogue: '/file-explorer-service/api/v2/preview-videos',
    getPreviewVideosList: '/file-explorer-service/api/v2/preview-videos/{id}',
    /* [COUPONS] */
    getSingleCouponDetails: '/publisher/coupon/couponid/{id}',
    expireCoupon: '/publisher/coupon/expire/{id}',

    /* [LIVE CLASS RECORDINGS] */
    getAllLiveClassRecordings: '/file-explorer-service/api/v2/preview-videos?type=LTR',
    /* [DELIVERY MANAGEMENT] */

    // [GET]
    getDeliveriesByStatus: '/delivery/api/v2/delivery/status',
    getDeliveryPackageById: '/delivery/api/v2/delivery/{packageId}',
    getBarcodeEnvelopes: '/delivery/api/v2/delivery/envelopes',
    // [PUT]
    updateDeliveryAddress: '/delivery/api/v2/delivery/address',
    processDeliveryPackage: '/delivery/api/v2/delivery/process',
    moveDeliveryToBeDispatched: '/delivery/api/v2/delivery/bulk/to-be-dispatched',
    updateDeliveryPackage: '/delivery/api/v2/delivery',
    // [POST]
    sendHandDeliveryOtp: '/delivery/api/v2/delivery/in-hand/otp/send/{deliveryPackageId}',
    resendHandDeliveryOtp: '/delivery/api/v2/delivery/in-hand/otp/resend/{deliveryPackageId}',
    verifyHandDeliveryOtp: '/delivery/api/v2/delivery/in-hand/otp/verify',
    downloadTrackingTemplate: '/delivery/api/v2/template',
    uploadTrackingIds: '/delivery/api/v2/tracking-pool/upload',
    bulkAssignTrackingIds: '/delivery/api/v2/delivery/bulk-assign-tracking',
    bulkClearTrackingIds: '/delivery/api/v2/delivery/bulk-clear-tracking',
    // [GET]
    getStudentInfo: '/students/student/info',
    getStudentsList: '/students/api/v2/students/info',
    getStudentsList: '/students/api/v2/students/info',
    getSubscriptionsList: '/students/subscription/studentid',
    getSubscribedAddonsList: '/students/student/subscribed-addons',
    getInvoicesList: '/payments/student/subscription/studentid',
    verifyStudentEmail: '/users/user/autoverify/email_otp',
    getInvoice: '/payments/invoice/orderid/{orderId}',
    // [Batch management]
    getBatchList: '/batch/getAllBatch/pagination?page=0&size=10000',
    getBatchListPagination: '/batch/getAllBatch/pagination',
    createBatch: '/batch/createBatch',
    updateBatch: '/batch/updateBatch',
    closeBatch: '/batch/closeBatch/{batchId}',
    reactivateBatch: '/batch/api/v1/batches/{batchId}/reactivate',
    getBranchList: '/batch/getAllBranch',
    createBranch: '/batch/createBranch',
    getProgramList: '/batch/getAllProgram',
    createProgram: '/batch/createProgram',
    getScheduler: '/users/user/role/{roleName}',
    getBatchDetails: '/batch/getBatchById/{batchId}',
    uploadStudents: '/batch/bulkUpload',
    updateBatchOfStudents: '/batch/updateStudentsBatch',
    getStudentsListByBatch: '/batch/batch/{batchId}/allStudentIds',
    getStudentsListByStudentIds: '/students/student/byStudentIds',
    // [Group management]
    getGroupList: '/batch/groups',
    createGroup: '/batch/group',
    deleteGroup: '/batch/groups/{groupId}',
    updateGroup: '/batch/group',
    // [Feature Management]
    getFeatureList: '/publisher/storemanager/programs/features',
    updateFeature: '/publisher/storemanager/programs/features',
    createFeature: '/publisher/storemanager/programs/features',
    // [Scholarships]
    scholarship: '/publisher/api/v1/scholarship',
    scholarshipTypes: '/publisher/api/v1/scholarship/types',
    checkoutScholarship: '/publisher/api/v1/scholarship/checkout',
    studentsScholarship: '/students/api/v1/student/scholarship',
    studentScholarshipPaymentInfo: '/payments/payment/scholarship',
    studentNonScholarshipPaymentInfo: '/payments/payment/details/{studentId}',
    nonScholarshipStudents: '/students/api/v1/students/profile-verification-status',
    nonScholarshipDocuments: '/students/api/v1/documents/verification-status',
    updateDocumentsOfNonScholarshipStudents: '/students/api/v1/documents/update',

    //[Hall Tickets]
    hallTickets: '/students/api/v1/student/hall-ticket',

    //[Scholarship Types]
    scholarshipTypeList: '/publisher/api/v1/scholarship-types/all',
    scholarshipTypeById: '/publisher/api/v1/scholarship-types/{id}',
    createScholarshipType: '/publisher/api/v1/scholarship-types/create',
    updateScholarshipType: '/publisher/api/v1/scholarship-types/update/{id}',
    toggleScholarshipTypeActive: '/publisher/api/v1/scholarship-types/delete/{id}',

    //[Document Types]
    documentTypeList: '/publisher/api/v1/document-types/all',
    documentTypeById: '/publisher/api/v1/document-types/{id}',
    createDocumentType: '/publisher/api/v1/document-types/create',
    updateDocumentType: '/publisher/api/v1/document-types/update/{id}',
    toggleDocumentTypeActive: '/publisher/api/v1/document-types/delete/{id}',

    //Finance Dashboard
    payments: '/payments/orders/invoices',

    // User Device
    resetDevice: '/users/v1/devices/primary/reset',
    requestPrimaryDeviceModification: '/users/v1/devices/primary/request', // POST
    fetchPrimaryDevices: '/users/v1/devices/primary/support', // GET
    retriveLastAccessedDevicesInfo: '/users/v1/devices/access/history', // POST

    //[Marketing Campaigns]
    campaigns: '/publisher/api/v1/campaigns',
    campaign: '/publisher/api/v1/campaigns/{campaignId}',
    createCampaign: '/publisher/api/v1/campaigns',
    updateCampaign: '/publisher/api/v1/campaigns',
    activateCampaign: '/publisher/api/v1/campaigns/{campaignId}/{active}',
    subcategoryStoreListings: '/publisher/subcategories/storelistings',
  },
};

export { apiEndpoints };
